







import { getFederationComponent } from '@src/federations/getFederationComponent';
import { SportOfferUIStore } from '@store/modules/ui/sportOffer/sports/sportsIndex';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'SportsSocialMicroFeed',
    setup() {
        const sportOfferUiStore = useVuexStore<SportOfferUIStore>('ui/sportOffer/sports');
        const currentSportId = sportOfferUiStore.getter('currentSportId');

        return {
            currentSportId,
        };
    },
    components: {
        SocialMicroFeedView: getFederationComponent(() => import('social/MicroFeedView')),
    },
});
